import { render, staticRenderFns } from "./ChooseLang.vue?vue&type=template&id=970c5060&scoped=true&"
import script from "./ChooseLang.vue?vue&type=script&lang=js&"
export * from "./ChooseLang.vue?vue&type=script&lang=js&"
import style0 from "./ChooseLang.vue?vue&type=style&index=0&id=970c5060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c5060",
  null
  
)

export default component.exports